import axios from 'axios';

const API_URL = process.env.API_URL;

export async function getListCredits(authorization) {
  const url = `${API_URL}/webclient/in-web-purchase/credit-list`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function getListSubscriptionPrice(authorization) {
  const url = `${API_URL}/webclient/subscription/subscription-plan`;
  return axios({
    url,
    method: 'get',
    headers: {
      Authorization: `${authorization.tokenType} ${authorization.accessToken}`,
    } }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}



// WEBPACK FOOTER //
// ./src/services/creditsamount.js